import {HttpEventType, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {ContactsService} from '../new-contacts/contacts.service';
import {Injectable} from '@angular/core';

@Injectable()
export class SentInterceptorService implements HttpInterceptor{

  constructor(private contactsService: ContactsService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    return next.handle(req).pipe(tap(event => {
      if (event.type === HttpEventType.Sent) {
        this.contactsService.changeSpinnerStatus();
      }
    }));
  }
}
